import React from 'react';
export function About() {
  return <section id="about" className="py-20 px-4 bg-white" data-id="element-17">
      <div className="max-w-6xl mx-auto" data-id="element-18">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-16" data-id="element-19">
          About Me
        </h2>
        <div className="flex flex-col md:flex-row items-center gap-10" data-id="element-20">
          <div className="w-full md:w-1/3 flex justify-center" data-id="element-21">
            <div className="w-64 h-64 rounded-full overflow-hidden shadow-lg" data-id="element-22">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/or157NBLtMeTuibLq7hRvV/ChatGPT_Image_Jul_22%2C_2025%2C_01_52_19_PM.png" alt="Adeyeye Afeez" className="w-full h-full object-cover" data-id="element-23" />
            </div>
          </div>
          <div className="w-full md:w-2/3" data-id="element-24">
            <h3 className="text-2xl font-semibold text-gray-800 mb-4" data-id="element-25">
              Adeyeye Afeez
            </h3>
            <p className="text-lg text-gray-600 mb-6" data-id="element-26">
              I'm a passionate content writer with expertise in creating
              engaging and impactful content that resonates with readers and
              delivers results for clients.
            </p>
            <p className="text-lg text-gray-600 mb-6" data-id="element-27">
              My specialties include blog posts, SEO articles, website content,
              and creative storytelling. I combine research skills with a keen
              understanding of audience needs to craft content that informs,
              engages, and converts.
            </p>
            <p className="text-lg text-gray-600" data-id="element-28">
              With a dedication to quality and a commitment to meeting client
              objectives, I strive to deliver content that exceeds expectations
              and helps businesses achieve their goals.
            </p>
          </div>
        </div>
      </div>
    </section>;
}